import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./SiteHub.css";

/**
 * Owner-only bookmark page — not linked from customer Brand Hub nav/footer.
 * Direct URL: /owner
 */
export default function OwnerAccess() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    document.title = "Owner access — Not Broken Forever";
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div className="nbf-hub" dir="ltr" style={{ minHeight: "100vh", padding: "2rem" }}>
      <div className="nbf-hub__shell nbf-hub__narrow">
        <h1 style={{ marginTop: 0 }}>Owner access</h1>
        <p style={{ color: "var(--nbf-body, #c5d0e6)" }}>
          Internal management consoles. Customer products stay on the public homepage.
        </p>
        <div style={{ display: "grid", gap: "1rem", marginTop: "1.5rem" }}>
          <Link className="nbf-hub__btn nbf-hub__btn--card" to="/admin/login">
            Inner Voice Admin
          </Link>
          <a className="nbf-hub__btn nbf-hub__btn--ghost" href="/admin/marketing/login">
            Marketing Admin
          </a>
        </div>
        <p style={{ marginTop: "2rem", fontSize: "0.9rem", color: "var(--nbf-muted, #8b9cb8)" }}>
          Both destinations require separate authentication. This page does not grant access by itself.
        </p>
      </div>
    </div>
  );
}
